import { useSyncExternalStore } from 'react'
import type { CardMark } from '@/core/views/viewConfig'
import { currentVariant } from '@/core/data/session'
import { descriptionFor } from '@/variants'

const NONE: ReadonlyMap<string, CardMark> = new Map()
const noSubscribe = () => () => {}
const noMarks = () => NONE

export function useCardMarks(): ReadonlyMap<string, CardMark> {
  const activity = descriptionFor(currentVariant()).cardActivity
  return useSyncExternalStore(activity?.subscribe ?? noSubscribe, activity?.cardMarks ?? noMarks, activity?.cardMarks ?? noMarks)
}
